// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/check.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function CheckIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M14.0581 3.05769C14.3022 2.81386 14.6988 2.8137 14.9428 3.05769C15.1866 3.30171 15.1866 3.69844 14.9428 3.94246L5.94282 12.9425C5.69883 13.1865 5.30216 13.1863 5.05806 12.9425L1.05806 8.94246C0.813981 8.69838 0.813981 8.30177 1.05806 8.05769C1.30216 7.81386 1.69883 7.8137 1.94282 8.05769L5.50044 11.6153L14.0581 3.05769Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
